import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { httpsCallable } from "firebase/functions";
import { fireDb, fireFunctions } from "../../../../Firebase/firebase";
import { doc, getDoc } from "firebase/firestore/lite";
import { setUser } from "../../../../Redux/userSlice";
import styled from "styled-components";
import PropTypes from "prop-types";
import UnlinkButton from "./UnlinkButton";
import UnlinkLoader from "./UnlinkLoader";
import VoterInfo from "./VoterInfo";
import { desktopMarginsCutoff } from "../../../../styleConstants";

const VoterSectionText = styled.div`
  color: rgba(0, 0, 0, 0.85);
`;

const VoterInfoWrapper = styled.div`
  margin-top: 14px;

  // this essentially limits the stretch of the border bars to match the text above but not run all the way on desktop.
  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    max-width: 680px;
  }
`;

const ParticipationNote = styled.div`
  margin-top: 4px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
`;

const NotYouMutedNote = styled.div`
  margin-top: 12px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
`;

const UnlinkButtonWrapper = styled.div`
  margin-top: 8px;
`;

const LoadingWrapper = styled.div`
  margin-top: 14px;
`;

const VoterLinked = ({ snapshot }) => {
  const dispatch = useDispatch();
  const userFull = useSelector((state) => state.user.value);
  const [loading, setLoading] = useState(false);

  const handleUnlink = async () => {
    setLoading(true);
    const unlinkVoterFn = httpsCallable(fireFunctions, "unlinkVoter");
    await unlinkVoterFn({ fsUserId: userFull.fsDocId });
    const userDocRef = doc(fireDb, "unverifiedUsers", userFull.fsDocId);
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      dispatch(setUser({ fsDocId: userFull.fsDocId, ...userDoc.data() }));
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <LoadingWrapper>
        <UnlinkLoader />
      </LoadingWrapper>
    );
  }

  return (
    <>
      <VoterSectionText>Linked Voter:</VoterSectionText>
      <ParticipationNote>
        You are participating in petitions as this voter. Your stances are
        counted in each petition&apos;s verified tally.
      </ParticipationNote>
      <VoterInfoWrapper>
        <VoterInfo snapshot={snapshot} />
      </VoterInfoWrapper>
      <NotYouMutedNote>Not you? Unlink or contact us.</NotYouMutedNote>
      <UnlinkButtonWrapper>
        <UnlinkButton onClick={handleUnlink} />
      </UnlinkButtonWrapper>
    </>
  );
};

VoterLinked.propTypes = {
  snapshot: PropTypes.object,
};

export default VoterLinked;
